import React from 'react';

const MultipleChoiceQuestionBlock = ({ question, register, errors }) => {
    return (
        <div className="mb-4">
            <label className="form-label d-block mb-0">
                {question.title} {question.required && "*"}
            </label>
            {question.description && (
                <p className="text-muted"><small>{question.description}</small></p>
            )}
            {question.options?.map((opt) => (
                <div className="form-check" key={opt.id}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        value={opt.value}
                        {...register(question.internalId, {
                            required: question.required ? `${question.title} is required` : false,
                        })}
                    />
                    <label className="form-check-label">{opt.text}</label>
                </div>
            ))}
            {errors[question.internalId] && (
                <div className="text-danger small">{errors[question.internalId].message}</div>
            )}
        </div>
    );
};

export default MultipleChoiceQuestionBlock;